// This is what is reflected in a attribute object (technically there is a 'd' but for the purposes
// of this service, there are only the two)
export const PERMISSION_TYPE = <const>{
	READ: 'r',
	WRITE: 'w',
};

// This is what is reflected on the permission object
export const PERMISSION_MODE = <const>{
	[PERMISSION_TYPE.READ]: 'read',
	[PERMISSION_TYPE.WRITE]: 'write',
};
